document.addEventListener(
  'toggle',
  (event) => {
    const details = event.target;

    if (!(details instanceof HTMLDetailsElement) || !details.classList.contains('benoit-mobile-menu__submenu')) {
      return;
    }

    const summary = details.querySelector(':scope > summary');
    summary?.setAttribute('aria-expanded', details.open ? 'true' : 'false');
  },
  true
);

document.addEventListener('click', (event) => {
  const link = event.target instanceof Element ? event.target.closest('.benoit-mobile-menu__panel a') : null;

  if (!link) return;

  const drawer = link.closest('header-drawer');
  drawer?.close?.();
});
